import {
  Badge,
  Cushion,
  FlexContainer,
  Grid,
  Image,
  Rectangle,
  Typography,
} from '@pitchero/react-ui';
import { DateTime } from 'luxon';
import PropTypes from 'prop-types';
import React from 'react';
import Icon from '../icon';
import CLUB_PROP_TYPES from '../../lib/prop-types/club';
import ClubLink from '../club-link';

const ClubEvent = ({ event, club }) => {
  const renderInfoRow = (
    <Grid columns="36px 1fr" columnGap="10px" alignItems="center">
      {club.logo ? (
        <Image
          src={club.logo}
          alt={club.name}
          height={36}
          width={36}
          transformation="square"
          loading="lazy"
        />
      ) : (
        <Badge size="36" />
      )}
      <FlexContainer flexDirection="column" style={{ gap: '5px' }} justifyContent="center">
        <Typography preset="document" size={14}>
          {event.title}
        </Typography>
        {event.location && (
          <Typography preset="description" size={12} color="dustygray">
            {event.location}
          </Typography>
        )}
      </FlexContainer>
    </Grid>
  );

  return (
    <ClubLink route="calendar.event" params={{ _title: event.title, id: event.id }}>
      <a>
        <FlexContainer
          flexDirection="column"
          style={{
            minHeight: '150px',
            backgroundColor: '#fff',
            boxSizing: 'border-box',
            padding: '16px',
          }}
          component="div"
        >
          <FlexContainer
            justifyContent="space-between"
            alignItems="center"
            style={{ paddingBottom: '20px' }}
          >
            <Rectangle fill="#F8E8FD" radius="rounded">
              <Cushion all="xsmall">
                <Typography color="#A316CF" size={14} weight={600} transform="uppercase">
                  Club Events
                </Typography>
              </Cushion>
            </Rectangle>
            <Typography size={14} color="#666">
              {`${DateTime.fromISO(event.start).setZone(club.timezone).toFormat('HH:mm')}
               - ${DateTime.fromISO(event.end).setZone(club.timezone).toFormat('HH:mm')}`}
            </Typography>
          </FlexContainer>
          <FlexContainer
            flexDirection="column"
            justifyContent="center"
            style={{ height: '100%', margin: 'auto 0' }}
          >
            <Grid columns="1fr auto" rowGap="small">
              <Grid alignItems="center" alignContent="center" style={{ paddingRight: '5px' }}>
                {renderInfoRow}
              </Grid>
              <Grid columns="1fr 20px" alignItems="center" justifyContent="end" columnGap="5px">
                <Typography preset="body--small" color="#000" />
                <Icon name="arrow-right" color="gray" size={16} />
              </Grid>
            </Grid>
          </FlexContainer>
        </FlexContainer>
      </a>
    </ClubLink>
  );
};

ClubEvent.propTypes = {
  event: PropTypes.shape({
    end: PropTypes.string,
    id: PropTypes.number,
    sortType: PropTypes.string,
    start: PropTypes.string,
    location: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
  club: CLUB_PROP_TYPES.isRequired,
};

export default ClubEvent;
